import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { EdmStatus } from 'api/types/edm';
import type { ILead } from 'api/types/lead';
import type { IRequestException } from 'api/types/requestException';

interface IUpdateStatuses {
    propertyLeadIds: Array<ILead['propertyLeadId']>;
    status: EdmStatus;
}

const updateStatuses = async ({
    propertyLeadIds,
    status,
}: IUpdateStatuses): Promise<Response> => {
    const response = await apiClient.patch('edms', {
        json: {
            propertyLeadIds,
            status,
        },
    });
    return response;
};

export const useUpdateEdmStatusesMutation = (
    options: UseMutationOptions<Response, IRequestException, IUpdateStatuses>
) => {
    return useMutation(async (props) => await updateStatuses(props), options);
};
